import React from 'react';
import Reflux from 'reflux';
import Tracker from 'tracker';
import UserStore from 'stores/userStore';
import EventActions from 'actions/eventActions';
import EventStore from 'stores/eventStore';
import EventPaymentModal from 'views/EventPaymentModal';
import EventDetails from 'components/events/eventDetails';
import Messages from 'components/events/messages';
import VendorEventModal from 'components/user/VendorEventModal';

export default class extends Reflux.Component {
    static PropTypes = {
        event: React.PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.stores = [UserStore, EventStore];
        this.tracker = new Tracker();
    }

    getHeaderLine() {
        const types = [];

        this.props.event.leads.forEach((lead) => {
            if (types.indexOf(lead.vendor_type) < 0) {
                types.push(lead.vendor_type);
            }
        });

        if (types.length === 1) {
            if (types[0] === 'Venue') {
                return <h4>Venue Messages</h4>;
            } else if (types[0] === 'Caterer') {
                return <h4>Caterer Messages</h4>;
            }
        }

        return <h4>Vendor Messages</h4>;
    }

    eventPaidFor = () => {
        EventActions.paidFor();
    };

    closeVendorModal = () => {
        this.props.event.seen_modal = true;
        EventActions.seenVendorTutorial();
    };

    showVendorModal() {
        return this.props.event.seen_modal !== true && this.props.event.vendor_name;
    }

    showPaywall() {
        return !this.showVendorModal() &&
            this.props.event.pricing_model_test === true &&
            this.props.event.show_payment_modal === true &&
            this.props.event.paid_for !== true;
    }

    render() {
        return (
            <div className="event-details">
                <div className="container">
                    {this.showVendorModal() && <VendorEventModal vendorName={this.props.event.vendor_name} onClose={this.closeVendorModal} />}
                    {this.showPaywall() && <EventPaymentModal eventId={this.props.event.id} onPaymentSuccess={this.eventPaidFor} />}

                    <EventDetails event={this.props.event} />

                    <div className="event-lead">
                        {this.props.event.pricing_model_test !== true && this.getHeaderLine()}

                        {this.props.event.pricing_model_test !== true && this.props.event.leads.length === 0 && <div className="empty-message">Venues and vendors that can accommodate your event will respond here.</div>}
                        {this.props.event.pricing_model_test === true && <div className="empty-message">Thanks so much for using Revelr! We'll be in touch shortly. We look forward to working with you on your event.</div>}
                        {this.props.event.leads.length > 0 && <Messages event={this.props.event} />}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/events/details.jsx